import {ApplicationStoreType} from 'reducers';
import {QuoteItemsType, TotalsType} from 'constants/flow/flowTypesCart';

/**
 * Returns all quote items
 * @param {ApplicationStoreType} store - Store application
 * @returns {QuoteItemsType} - items
 */
export const getAllQuote = (store: ApplicationStoreType): QuoteItemsType => store.quoteItems;

/**
 * Returns totals information of quote items
 * @param {ApplicationStoreType} store - Store application
 * @returns {TotalsType | {}} - Totals information
 */
export const getTotalsQuoteItems = (store: ApplicationStoreType): TotalsType | {} =>
    getAllQuote(store).totals || {};
